import React from "react";

const About = () => {
  return <></>;
};

export default About;
